import './rooms.scss';
import { Model, SCENE_EVENTS } from './components/MVC/Model';
import { FriendsHelper } from './components/MVC/friendsHelper';
import RoomsController from './components/Controllers/Rooms';
import { Socket } from './socket/Socket';
import RoomSocket from './socket/RoomSocket';
import DeleteConfirmationModal from './components/Modals/Space/DeleteConfirmationModal';
import SpaceBrowserUserList from './components/Peoples/SpaceBrowserUserList';


console.log('Welcome to bagless rooms page!')

// Make DeleteConfirmationModal globally available
window.DeleteConfirmationModal = DeleteConfirmationModal;

new RoomsController();
// new NavController();


let CONFIG = {
  "socketUrl": "test",
};
aptis.home = new Class({
  // _worldId: 0,
  // _baseUrl: '',
  // _urls: {},
  initController: function (config) {
    console.log('config ', config);
    CONFIG = { ...CONFIG, ...this.config };
  }
});


const initRoomsPage = () => {
  // const preloader = new Preloader();
  console.log('window.onload');
  CONFIG = { ...CONFIG, ...room_config.socketConfig }
  const model = new Model({ mode: 'room', CONFIG });
  let view;
  let socket;
  window.CONFIG = room_config.socketConfig;
  // if (!room_config.socketConfig.isGuest) {
  //   socket = new RoomSocket({ model, ...room_config.socketConfig });
  //   model.socket = socket;
  //   const friendsHelper = new FriendsHelper({ model, socket });
  //   socket.init(room_config.socketConfig);
  // }

  // new RoomsController();
  console.log('room.js model', model)

  // Initialize SpaceBrowserUserList
  const spaceBrowserUserList = new SpaceBrowserUserList({ model });

  // Add click event handler for online users count
  $(document).on('click', '.room-online-users', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const roomCard = $(this).closest('.room-card');
    const spaceId = roomCard.data('space-id');

    if (spaceId) {
      spaceBrowserUserList.open(this, spaceId);
    } else {
      console.error('Space ID not found on room card');
    }
  });


  model.addEventListener(SCENE_EVENTS.SCENE_DATA_RECIEVED, () => {
    socket = new Socket({ model, CONFIG });
    window.socket = socket;

    //   const traffic = new Notification({ model, socket });
    //   const userProfile = new UserProfile({ model });
    //   const joinSceneModel = new JoinSceneModal({ model });
    //   const joinWorldModal = new JoinWorld({ model });
    //   const sendOfflineMessagesModal = new SendOfflineMessageModal({ model, socket });
    //   model.sendOfflineMessagesModal = sendOfflineMessagesModal;
    //   const tracking = new UserTracking({ model });


  });
  // const callback = () => {

  //   if (view)
  //     return;

  //   viewType = 'view';
  //   $('body').addClass('view-mode');

  //   view = new ModeView({ model, preloader });
  //   const webRtc = new WebRtc({ socket, model });
  // };

  // model.getSceneData({
  //   url: reqUrl, onOk: () => { callback(); }
  // });

  // // Service worker
  // if ('serviceWorker' in navigator) {
  //   // navigator.serviceWorker.register('./serviceworker.js')
  //   //                        .then(reg => console.log('Success: ', reg.scope))
  //   //                        .catch(err => console.log('Failure: ', err));
  // }

  // // Store logo image to localstorage
  // if (!localStorage.getItem('bagless_logo')) {
  //   const thumbnailImageObj = document.getElementById('ref_logo');

  //   const canvas = document.createElement("canvas");
  //   canvas.width = thumbnailImageObj.width;
  //   canvas.height = thumbnailImageObj.height;

  //   const ctx = canvas.getContext("2d");
  //   ctx.drawImage(thumbnailImageObj, 0, 0);

  //   const dataUrl = canvas.toDataURL("image/png");

  //   localStorage.setItem('bagless_logo', dataUrl);
  // } else {
  //   $("#ref_logo").remove();
  // }

};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRoomsPage);
} else {
  initRoomsPage();
}
